var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('FieldView'),_vm._l((_vm.posts),function(key){return _c('PostView',{key:key,attrs:{"id":key}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }